import axios from 'axios';
import { decryptData } from './crypto';

const aprecomAxios = axios.create({
  timeout: 30000,
});

aprecomAxios.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      config.headers = {};
    }

    // Always encrypted
    config.headers['X-Encrypt'] = 'true';

    // Login APIs should NOT send Authorization
    const isLoginApi =
      config.url?.includes('/login') ||
      config.url?.includes('/cnms/token');

    if (!isLoginApi) {
      const token = decryptData(localStorage.getItem('aprecom_token'));

      if (token && token !== null && token !== 'null') {
        config.headers.Authorization = token;
      }
    }

    // Default JSON unless overridden
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => Promise.reject(error)
);


aprecomAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.errors?.[0]?.message || '';

    const isTokenExpired =
      message.includes('jwt expired') ||
      message.includes('jwt malformed') ||
      message.includes('invalid signature');

    if (isTokenExpired) {
      console.warn('[Aprecom] Token expired, logging out');
      localStorage.removeItem('aprecom_token');
    }

    return Promise.reject(error);
  }
);

export default aprecomAxios;